import lf from 'lovefield'

export function const_phases (schemaBuilder) {
  schemaBuilder.createTable('const_phases')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('ordre', lf.Type.INTEGER)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('coutendeblai', lf.Type.INTEGER)
      .addColumn('coutenremblai', lf.Type.INTEGER)
      .addColumn('coutenreglage', lf.Type.INTEGER)
      .addPrimaryKey(['id'])
      // .addUnique('code', ['code'])
      .addNullable(['coutendeblai', 'coutenremblai', 'coutenreglage']);
}


/*

CREATE TABLE IF NOT EXISTS `const-phases` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(4) NOT NULL,
  `ordre` tinyint(4) NOT NULL,
  `nom` varchar(20) NOT NULL,
  `deblai` tinyint(1) NOT NULL,
  `remblai` tinyint(1) NOT NULL,
  `reglage` tinyint(1) NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `code` (`code`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=9 ;

*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constPhases.schema.js